module.exports = __webpack_public_path__ + "img/aiyouth-qr.368bd931.png";